import { useMemo } from 'react';
import LoadingIcons from 'react-loading-icons';
import { colors } from '../../colors';
import './index.css';
import InputField from './InputField';

export enum Validations {
  Required = 'REQUIRED',
  NonZero = 'NON_ZERO',
  NumberTyping = 'TYPE_NUMBER',
  BooleanTyping = 'TYPE_BOOLEAN',
  BalanceTypeTyping = 'TYPE_BALANCE_TYPE',
  DateTyping = 'TYPE_DATE',
  DirectionType = 'TYPE_DIRECTION',
  MrcStateType = 'TYPE_MRC_STATE',
  OrderType = 'TYPE_ORDER_TYPE',
  MaximumExceeded = 'MAXIMUM_EXCEEDED',
  MinimumRequired = 'MINIMUM_REQUIRED',
  Minimum50Required = 'MINIMUM_50_REQUIRED',
  ConnectionRefused = 'CONNECTION_REFUSED',
  InvalidEmail = 'INVALID_EMAIL',
  OutOfSyncPassword = 'OUT_OF_SYNC_PASSWORD',
}

export type Field = {
  label: string;
  value: string | undefined;
  handleValueChange: any;
  error?: Validations;
  isSecret?: boolean;
  isLocked?: boolean;
  title?: string;
  shouldFit?: boolean;
  handleEnterPress?: () => void;
  fieldMaxSize?: number | undefined;
  isDisabled?: boolean;
};

export type Dropdown = {
  label: string;
  options: any[];
  value: any | undefined;
  handleValueChange: any;
  isLocked?: boolean;
  shouldFit?: boolean;
  isDisabled?: boolean;
  fullWidth?: boolean;
  labelFormatter?: (option: string) => string;
};

type FormConfig = {
  title: string;
  formMessage?: {
    success: boolean;
    message: string;
  };
  fields: Array<Field>;
  handleSubmit: () => void;
  isLoading?: boolean;
};

interface Props {
  config: FormConfig;
}

const Form = (props: Props) => {
  const { config } = props;
  const { title, fields, handleSubmit, formMessage, isLoading } = config;

  const formMessageColor = useMemo(
    () => (formMessage?.success ? colors.green : colors.red),
    [formMessage?.success],
  );

  return (
    <div className="form-container">
      <p className="form-title">{title}</p>
      {!!formMessage && (
        <p className="form-message" style={{ color: formMessageColor }}>
          {formMessage.message}
        </p>
      )}
      <div>
        {fields.map((field) => (
          <InputField config={field} key={field.label} />
        ))}
      </div>
      <div className="form-submit-button" onClick={handleSubmit}>
        {isLoading ? (
          <LoadingIcons.Grid width={20} />
        ) : (
          <span className="form-submit-text">Submit</span>
        )}
      </div>
    </div>
  );
};

export default Form;
